

export default {
  kategoriList: [],
  totalRecords: 0,
  totalFiltered: 0
}
